import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { installPreloadErrorGuard } from '@mbbe/config';
import { ChunkLoadBoundary, ErrorBoundary } from '@mbbe/ui';
import { mainRecovery } from './lib/chunkRecovery';
import { MainChunkRecovery } from './lib/MainChunkRecovery';
import { LanguageProvider } from './contexts/LanguageContext';
import App from './App';
import DestekApp from './destek/DestekApp';
import { isDestekHost } from './destek/isDestekHost';
import OpsApp from './ops/OpsApp';
import { isOpsHost } from './ops/isOpsHost';
import PortalApp from './portal/PortalApp';
import { isPortalHost } from './portal/isPortalHost';
import { createAppQueryClient } from './lib/queryClient';
import './index.css';

// Stale-deploy guard: a tab opened before a deploy holds an index.html that
// references hashed chunks which no longer exist, so lazy-route imports 404.
// The shared recovery controller reloads automatically only when no screen holds
// unsaved or pending work, only a bounded number of times, and never when it cannot
// record the attempt. Otherwise it shows an accessible update prompt. Route-level lazy
// boundaries (ChunkLoadBoundary) use the same controller for their manual reload action.
installPreloadErrorGuard(mainRecovery);

const queryClient = createAppQueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <LanguageProvider>
        <QueryClientProvider client={queryClient}>
          <MainChunkRecovery>
            {isOpsHost() ? <OpsApp /> : isDestekHost() ? <DestekApp /> : isPortalHost() ? <PortalApp /> : <ChunkLoadBoundary><App /></ChunkLoadBoundary>}
          </MainChunkRecovery>
        </QueryClientProvider>
      </LanguageProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
